import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { Subject } from 'rxjs';
import { Airport } from 'src/app/api/airport.service';

@Component({
    selector: 'app-airport-dropdown',
    templateUrl: './airport-dropdown.component.html',
    styleUrls: ['./airport-dropdown.component.scss'],
    imports: [SelectModule, FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AirportDropdownComponent),
            multi: true
        }
    ],
})
export class AirportDropdownComponent {

  constructor() { }

  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;
  isTouched = false;

  selectedAirport: Airport | undefined;
  dropdownItems: Airport[] = []

  private _airports: Airport[] = [];
  @Input() set airports(value: Airport[]) {

    this._airports = [...value].sort((a, b) => a.aircode.localeCompare(b.aircode))
    this.dropdownItems = this._airports
  }

  get airports(): Airport[] {
    return this._airports;
  }


  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  writeValue(value: string | number): void {

    if (value) {
      this.selectedAirport = this.dropdownItems.find(a => a.id === (typeof value === "string" ? Number.parseInt(value, 10) : value))
    }
    else {
      this.selectedAirport = undefined
    }

  }


  onAirportSelected(event: Airport) {
    this.onChange(event.id)
  }

  touched() {
    if (!this.isTouched) {
      this.isTouched = true
      this.touched()
    }
    
  }
}
